import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Joins class names and lets the last one win.
 *
 * A component's recipe sets a padding and a caller passes another; without a
 * merge both land in `class` and the winner is whichever Tailwind emitted
 * later — an ordering nothing in the source shows. `twMerge` knows which
 * utilities occupy the same slot and drops the earlier one, so `className` on
 * a call site overrides rather than fights.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
